export default __webpack_public_path__ + "static/media/text-field.5caddb94.svg";